import script from "./BarberSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BarberSelectionModal.vue?vue&type=script&setup=true&lang=js"

import "./BarberSelectionModal.vue?vue&type=style&index=0&id=51471245&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51471245"]])

export default __exports__